module.exports = __webpack_public_path__ + "img/15.1c13553c.svg";